import { Theme } from '@mui/material/styles/createTheme';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  addExerciseWrapper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 4,
    padding: 16,
    marginTop: 8,
  },
  addExerciseHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  addExerciseForm: {
    width: '100%',
  },

  exerciseOptionItem: {
    padding: '4px 8px',
    minWidth: 200,
  },

  addExerciseCategoryItem: {
    maxWidth: 'unset',
  },

  formItem: {
    marginTop: '8px !important',
  },

  title: {
    fontWeight: 500,
    fontStyle: 'normal',
    color: theme.palette.grey[600],
    paddingBottom: 4,
  },

  uploadFileButton: {
    height: 32,
    lineHeight: '24px',
    padding: '4px 8px',
    display: 'inline-flex',
    marginBottom: 4,
    '& svg': {
      marginRight: 8,
    },
  },

  optionsContainer: {
    display: 'flex',
    gap: 4,
    flexWrap: 'wrap',
  },

  addOptionButton: {
    borderRadius: 2,
    textTransform: 'capitalize',
    backgroundColor: 'transparent',
    lineHeight: 18,
    height: 26,
    padding: '4px 8px',
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
  },

  optionItem: {
    padding: '4px 8px',
    background: theme.palette.grey[200],
    borderRadius: 2,
    color: theme.palette.grey[600],
    display: 'flex',
    alignItems: 'center',
    height: 26,
  },

  deleteTag: {
    width: 20,
    height: 20,
    minWidth: 0,
    padding: 0,
    marginLeft: 8,
    backgroundColor: theme.palette.grey[200],
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',

    '&:hover svg path': {
      fill: theme.palette.primary.main,
    },

    '& svg path': {
      fill: theme.palette.grey[600],
    },
  },

  buttonWrapper: {
    padding: '16px 0',
  },
  filesWrapper: {
    marginTop: 8,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  selectorWithContent: {
    '& .MuiOutlinedInput-root': {
      minHeight: '48px',
    },
  },
  languageWrapper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),

    '& > div + div': {
      margin: '0 !important',
    },
  },
}));
